export const FAILED_ADDRESS_VALIDATION = 'failed_address_validation';

export const VERIFICATION_REQUIRED_ERROR = 'VERIFICATION_REQUIRED_ERROR';

export const UNEXPECTED_ERROR = 'We hit an unexpected error. Please try again.';

export const MONTHLY_LABEL_LIMIT_EXCEEDED =
  'You have exceeded the monthly label limit for your plan.';

export const UNABLE_TO_PROCESS_REQUEST =
  'We were not able to process your request. Please try again.';
